module.exports = __webpack_public_path__ + "media/images/energieakademie-f495593e92f1b9ad1630d1c6eb9184e9.png";